import {MI} from "../init";

/**
 * @constructor
 * @param {Game} game
 * @returns {FsInfo}
 */
export function FsInfo(game) {

	/** @type {Game} */
	this._game = game;

//	/** @type {MadnesObject} */
//	this._logo;

	/** @type {MadnesObject} */
	this._info;
	/** @type {MadnesObject} */
	this._infoTxtCount;

//	this._onShow;

	/** @type {boolean} */
	this._hided = true;

	/** @type {MadnesTween} */
	this._tweenShow;
	/** @type {MadnesTween} */
	this._tweenHide;

	this._hideY = -110;

}

//FsInfo.prototype.setOnShow = function(func) {
//	this._onShow = func;
//};

///** @param {MadnesObject} logo */
FsInfo.prototype.create = function(/*logo*/) {

//	this._logo = logo;

	this._info = MI.addImg(MI.getWi() / 2, this._hideY, "fs_bg");
	this._info.setAnchor(0.5, 0);
	this._info.setVisible(false);
//	this._fsGroup.add(this._info);

	this._infoTxtCount = MI.addBitmapText("font_free_spins", 106, -26, "0/0", 72);
	this._infoTxtCount.setAnchor(0.5, 0);
	this._info.addChild(this._infoTxtCount);

	this._hided = true;
};

/**
 * @param {number} count
 * @param {number} all
 */
FsInfo.prototype.set = function(count, all) {
	this._infoTxtCount.setText(count + "/" + all);
};

/**
 * @param {number=} duration
 * @returns {Promise}
 */
FsInfo.prototype.show = function(duration) {
	var _self = this;

	if(typeof duration === 'undefined') { duration = 200; };

	return new Promise(function(res) {

		_self._tweenHide && _self._tweenHide.stop();

		_self._info.revive();

		if(!_self._hided) {
			res();
			return;
		}

		_self._tweenShow = MI.addTween().to(_self._info, { 'y': 0 }, {
			'duration': duration,
			//'easing': MadnesTween.getEasing("back_out"),
			'callback': function() {
				_self._info.setPosY(0);
				_self._hided = false;
				res();
			}
		});
	});
};

/**
 * @param {number=} duration
 * @returns {Promise}
 */
FsInfo.prototype.hide = function(duration) {
	var _self = this;

	if(typeof duration === 'undefined') { duration = 200; };

	return new Promise(function(res) {

		_self._tweenShow && _self._tweenShow.stop();

		if(_self._hided) {
			res();
			return;
		}

		MI.addTween().to(_self._info, { 'y': _self._hideY }, {
			'duration': duration,
			//'easing': MadnesTween.getEasing("back_out"),
			'callback': function() {
				_self._info.setPosY(_self._hideY);
				_self._info.kill();
				_self._hided = true;
				res();
			}
		});
	});
};

/**
 * @param {number} from
 * @param {number} to
 * @param {number} actual
 * @returns {Promise}
 */
FsInfo.prototype.count = function(from, to, actual) {

	var _self = this;

	return new Promise(function(res) {
		var obj = { 'count': from };
		var lastCount = 0;

		MI.addTween().to(obj, { 'count': to }, {
			'duration': 1000,
			'update': function() {
				var count = obj['count'] | 0;
				if(lastCount !== count) {
					_self._game.sounds["bonus_FreeSpins_Counter"].play();
				}
				lastCount = count;

				_self._infoTxtCount.setText(actual + "/" + count);
			},
			'callback': function() {
				_self._game.sounds["bonus_FreeSpins_Counter"].play();
				_self._infoTxtCount.setText(actual + "/" + to);
				res();
			}
		});
	});
};

FsInfo.prototype.destroy = function() {
	this._info.destroy();
	this._info = null;
	this._infoTxtCount = null;
};